import React, { useEffect, useState } from 'react';
import { DashboardLayout } from '../layouts/dashboard-layout/DashboardLayout';
import { ERouterPath } from '../features/router/ERouterPath';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { UserRelationRoleEnum } from '../api/types';
import { ApplicationState } from '../app/store';
import { ISessionAppState } from '../app/session/reducer';

export const Dossier = (): JSX.Element => {
  const { relation } = useSelector<ApplicationState, ISessionAppState>(state => state.session);
  const history = useHistory();

  const isMobileMode = (): boolean => {
    const { innerWidth } = window;
    return innerWidth <= 767; // 767 = $tablet-breakpoint in _library.scss
  };

  const [inMobileMode, setInMobileMode] = useState<boolean>(isMobileMode());

  useEffect(() => {
    const resizeUpdate = () => {
      const mobileMode = isMobileMode();
      if (mobileMode !== inMobileMode) {
        setInMobileMode(mobileMode);
      }
    };

    window.addEventListener('resize', resizeUpdate);
    return () => window.removeEventListener('resize', resizeUpdate);
  }, [inMobileMode]);

  if (inMobileMode) {
    return <DashboardLayout showTabsInitially={true} />;
  } else {
    if (relation?.role === UserRelationRoleEnum.thirdParty) {
      // Is a third party of dossier
      history.replace(ERouterPath.chat);
    } else {
      // Is person
      history.replace(ERouterPath.reports);
    }
    return <DashboardLayout />;
  }
};
